export default "__VITE_ASSET__D93oxYm7__"